import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Calendar from 'react-calendar';
import moment from "moment";
import 'react-calendar/dist/Calendar.css';

const CalendarRender = ({onData, date}) => {

    return (
        <>
            <Calendar value={moment(date).toDate()}
                      className={"custom-react-calendar"}
                      locale={"vi-VI"}
                      navigationLabel={({ date, label, locale, view }) => {
                          return label.charAt(0).toUpperCase() + label.slice(1)
                      }}
                      onChange={(date) => onData(date)}/>
        </>
    )
}

export default CalendarRender
